import * as React from 'react';
import {Text, TextProps, TextType} from '../Text';

export interface LinkProps extends TextProps {
  url?: string;
  newTab?: boolean;
  type?: TextType;
}

export function Link({
  url = '',
  type = 'link',
  text = '',
  newTab = false,
  ...restProps
}: LinkProps) {
  return (
    <Text
      href={url || `https://${text}`}
      text={text}
      type={type}
      target={newTab ? '_blank' : '_self'}
      component="a"
      {...restProps}
    />
  );
}

export default Link;
